<section>
    <div class="wrapper">
        <div class="mrt-75">
        
            <div class="page-title">
                <label class="page-caption">Users</label>
            </div>
        
            <div class="add-button-box">
                <div class="col-sm-12">
                    <button (click)="onAddClick()" class="hand-link add-button">Add User</button>
                </div>
            </div>
        
            <div class="row" *ngIf="usersList.length > 0 && gridOptions">
                <ag-grid-angular class="data_scroll ag-theme-balham grid"
                    [rowData]="usersList" [columnDefs]="gridOptions.columnDefs"
                    [defaultColDef]="gridOptions.defaultColDef" [domLayout]="domLayout" (gridReady)="onGridReady($event)">
                </ag-grid-angular>
            </div>
            
            <div class="row" *ngIf="gridOptions && usersList.length === 0">
                <div class="col-12 text-center" style="padding: 40px;">
                    <h4>No Users Found</h4>
                    <p>There are no users to display. Click "Add User" to create a new user.</p>
                </div>
            </div>
        
            <ng-template #addUser let-c="close" let-d="dismiss">
                <div class="modal-header blue-bg" style="padding:10px !important;">
                    <h2 class="modal-title" style="margin:0px !important" id="modal-basic-title">{{popupHeading}}</h2>
                    <button type="button" style="color: white;" class="close" (click)="d('Close click')">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="col-md-12">
                        <label class="data">First Name</label>
                        <input class="form-control" placeholder="Enter First Name" type="text" [(ngModel)]="firstName" />
                    </div>
                    <div class="col-md-12">
                        <label class="data">Last Name</label>
                        <input class="form-control" placeholder="Enter Last Name" type="text" [(ngModel)]="lastName" />
                    </div>
                    <div class="col-md-12">
                        <label class="data">User Email</label>
                        <input class="form-control" placeholder="Enter Email ID" (blur)="onEmailChange()" type="email"
                            [(ngModel)]="userEmail" email />
                    </div>
                    <div class="col-md-12">
                        <!-- <p *ngIf="searchValue==0" class="validation-text">Please enter Email Id</p> -->
                    </div>
        
                    <div class="col-md-12">
                        <label class="roles">Roles</label>
                        <div *ngIf="rolesList.length > 0">
                            <div *ngFor="let role of rolesList">
                                <input type="checkbox" [name]="'role-' + role.id" [value]="role.id"
                                    [(ngModel)]="role.checked"> {{role.name}}
                            </div>
                        </div>
                    </div>
        
        
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn add-button custom-btn" (click)="saveUser()">Save</button>
                    <button type="button" class="btn cancel-btn" (click)="c('Close click')">Cancel</button>
                </div>
            </ng-template>

        </div>
            
    </div>
</section>
